(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardScheduleController", DeviceMessageBoardScheduleController)

    DeviceMessageBoardScheduleController.$inject = [
        "$rootScope",
        "$scope",
        "$stateParams",
        "$compile",
        "$filter",
        "eventsService",
        "$uibModal"
    ]

    function DeviceMessageBoardScheduleController(
        $rootScope,
        $scope,
        $stateParams,
        $compile,
        $filter,
        eventsService,
        $uibModal
    ) {

        const date = new Date()
        const d = date.getDate()
        const m = date.getMonth()
        const y = date.getFullYear()

        /**
            $scope variables
         **/
        $scope.date = new Date()

        /**
            Get events
            @type {{events: $scope.events.events}}
         **/
        $scope.events = {
            events: (start, end, timezone, callback) => {
                const events = []
                eventsService.getEvents($stateParams.message_board_id).then((data) => {
                    $scope.events = data

                    angular.forEach($scope.events, (value, key) => {
                        let end = ""
                        let start = ""

                        if(value.recurrence.start_date) {
                            start = $filter("date")(value.recurrence.start_date, "yyyy-MM-ddTHH:mm:ss")
                        } else {
                            start = new Date().setDate(new Date().getDate() - 365)
                        }

                        if(value.recurrence.end_date) {
                            end = $filter("date")(value.recurrence.end_date, "yyyy-MM-ddTHH:mm:ss")
                        } else {
                            end = new Date().setDate(new Date().getDate() + 365)
                        }

                        const event = {
                            id: value.id,
                            tooltip: "Start: " + value.start_message_name + "  End: " + value.end_message_name,
                            title: "Every "
                                + formatDay(value.recurrence.start_day)
                                + " at " + formatTime(value.recurrence.start_hour, value.recurrence.start_minute)
                                + " to "
                                + formatDay(value.recurrence.end_day)
                                + " at " + formatTime(value.recurrence.end_hour, value.recurrence.end_minute),
                            start: start,
                            end: end
                        }
                        events.push(event)
                    })

                    callback(events)
                })
            }
        }

        const formatDay = (recurrenceDay) => {
            let day = ""

            switch(recurrenceDay) {
                case 0:
                    day = "Sunday"
                    break
                case 1:
                    day = "Monday"
                    break
                case 2:
                    day = "Tuesday"
                    break
                case 3:
                    day = "Wednesday"
                    break
                case 4:
                    day = "Thursday"
                    break
                case 5:
                    day = "Friday"
                    break
                case 6:
                    day = "Saturday"
                    break
            }

            return day
        }

        const formatTime = (recurrenceHour, recurrenceMinute) => {

            let hours = recurrenceHour
            let minutes = recurrenceMinute
            let suffix = "am"

            //it is pm if hours from 12 onwards
            suffix = (hours >= 12)? "pm" : "am"

            //only -12 from hours if it is greater than 12 (if not back at mid night)
            hours = (hours > 12)? hours -12 : hours

            //if 00 then it is 12 am
            hours = (hours == "00")? 12 : hours

            minutes = (minutes <= 9)? "0" + minutes : minutes

            const formattedTime = hours + ":" + minutes + " " + suffix

            return formattedTime
        }

        /**
            Event modal
            @param {int} eventID
         **/
        $scope.eventModal = (eventID, timezone) => {
            $uibModal.open({
                templateUrl: "app/modals/event.view.html",
                controller: "EventModalController",
                resolve: {
                    eventID: () => {
                        return eventID
                    },
                    messageBoardTimezone: () => {
                        return timezone
                    },
                    messageBoard: () => {
                        return $scope.messageBoard
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        /* alert on eventClick */
        $scope.alertOnEventClick = ( date, jsEvent, view) => {
            if ($rootScope.can('DeviceOutputUpdate', $scope.messageBoard.device.customer_id)) {
                $scope.eventModal(date.id)
            }
        }
        /* alert on Drop */
        $scope.alertOnDrop = (event, delta, revertFunc, jsEvent, ui, view) => {
            $scope.alertMessage = ("Event Droped to make dayDelta " + delta)
        }
        /* alert on Resize */
        $scope.alertOnResize = (event, delta, revertFunc, jsEvent, ui, view ) => {
            $scope.alertMessage = ("Event Resized to make dayDelta " + delta)
        }
        /* add and removes an event source of choice */
        $scope.addRemoveEventSource = (sources,source) => {
            let canAdd = 0
            angular.forEach(sources, (value, key) => {
                if(sources[key] === source){
                    sources.splice(key,1)
                    canAdd = 1
                }
            })
            if(canAdd === 0){
                sources.push(source)
            }
        }
        /* remove event */
        $scope.remove = (index) => {
            $scope.events.splice(index,1)
        }
        /* Change View */
        $scope.changeView = (view,calendar) => {
            uiCalendarConfig.calendars[calendar].fullCalendar("changeView",view)
        }
        /* Change View */
        $scope.renderCalender = (calendar) => {
            if(uiCalendarConfig.calendars[calendar]){
                uiCalendarConfig.calendars[calendar].fullCalendar("render")
            }
        }
        /* Render Tooltip */
        $scope.eventRender = (event, element, view) => {
            element.attr({
                "uib-tooltip": event.tooltip,
                "tooltip-append-to-body": true
            })
            $compile(element)($scope)
        }

        /* config object */
        $scope.uiConfig = {
            calendar:{
                height: 475,
                editable: false,
                header:{
                    left: "today prev,title,next",
                    center: "",
                    right: "month agendaWeek agendaDay"
                },
                eventClick: $scope.alertOnEventClick,
                eventDrop: $scope.alertOnDrop,
                eventResize: $scope.alertOnResize,
                eventRender: $scope.eventRender
            }
        }

        /* event sources array*/
        $scope.eventSources = [
            $scope.events
        ]

        $scope.getScheduleData = () => {
            console.log($scope.events)
        }
    }
})()
